if ($(".reviews").length) {
  const storageKey = "storeRatingData-" + document.location.host;

  function generateStars(score) {
    const full = Math.floor(score);
    const half = score % 1 >= 0.5;
    let html = "";

    for (let i = 0; i < full; i++) {
      html += '<span class="star star-on"></span>';
    }
    if (half && full < 5) {
      html += '<span class="star star-half"></span>';
    }
    return html;
  }
  function renderRating(data) {
    // Ochrana proti neparsovanému JSON
    const d = typeof data === "string" ? JSON.parse(data) : data;

    const average = parseFloat(d.averageScore) || 0;
    const count = d.count || 0;
    const ratings = d.ratings?.slice(0, 4) || [];
    //console.log(d)
    const reviewHtml = ratings
      .map(
        (r) => `
        <div class="review-item">
          <div class="review-description">${r.description}</div>
          <div class="review-name">${r.fullName || translation('overenyzakaznik')}</div>
          <div class="review-stars"><span class="stars">${generateStars(parseFloat(r.score) || 0)}</span></div>
        </div>
      `,
      )
      .join("");
    ($(".reviews .topNumber").text(average.toFixed(1).replace(".", ",")), $(".reviews .count").text(count), $(".reviews .reviewsNumbers .stars").html(generateStars(parseFloat(average) || 0)), $(".reviews .right").html(reviewHtml));
    extraReviews();
  }
  sessionStorage.removeItem(storageKey); // Odstranění uložených dat při každém načtení stránky
  const stored = sessionStorage.getItem(storageKey);
  if (stored) {
    renderRating(JSON.parse(stored));
  } else {
    $.ajax({
      url: translation('urlhodnoceni'),
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Store-Rating-Details": "true",
      },
      success: function (response) {
        sessionStorage.setItem(storageKey, JSON.stringify(response));

        renderRating(response);
      },
      error: function (xhr, status, error) {
        console.error("Chyba při načítání hodnocení:", error);
      },
    });
  }
}

function extraReviews() {
  $(".overall-wrapper>.reviews .right").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    arrows: true,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
      { breakpoint: 450, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });

  if ($(".reviews .slick-slider").length) {
    $(".reviews .slick-slider").each(function () {
      var $wrapper = $('<div class="arrowWrapper"></div>');
      $(this).find(".slick-dots").after($wrapper);

      var $arrows = $(this).find(".slick-arrow");

      if ($arrows.length) {
        $arrows.each(function () {
          var $arrow = $(this);

          $arrow.appendTo($wrapper);
        });
      }
    });
  }
}
